import { map as rxjsmap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseServices } from '../../kuba.services';
import { Observable } from 'rxjs';
import { ActivityEditDto } from '../ohs-plan';
import { AuthenticationService } from 'src/app/_services';
import { LanguageId } from 'src/app/_models/language-id.enum';

@Injectable({
  providedIn: 'root'
})
export class FlexiServices {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) {}

  // bind business dropdown
  getAdvisor(businessId: number) {
    return this.http
      .get<any>(environment.BASE_URL + '/flexi/getadvisor/' + businessId).pipe(rxjsmap(result => result));
  }

  PostOHSData(ohsData) {
    return this.http
      .post(environment.BASE_URL + '/flexi/PostOHSContent', ohsData).pipe(rxjsmap((response: Response) => {
        return response;
      }));
  }

  updateOHSData(ohsData, id) {
    return this.http
      .put(environment.BASE_URL + '/flexi/updateOHSdata/' + id, ohsData).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  getOHSdata(businessId: number) {
    return this.http
      .get<any>(environment.BASE_URL + '/flexi/getOHSdata/' + businessId).pipe(rxjsmap(result => result));
  }

  generateOHSFile(
    reportData: any,
    businessId: number,
    cultureInfo: string,
    ohsId: number,
    userId: number
  ) {
    let dynamicType = 'application/pdf';
    let myData = JSON.stringify({ data: reportData });
    let url = `${environment.BASE_URL}/flexi/export-article/${businessId}/${cultureInfo}/${ohsId}/${userId}`;
    let crfToken = this.authenticationService.getCsrfToken();
    return Observable.create(observer => {
      let xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.withCredentials = true;
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Logo-Id', 'ab064fd4-9b4a-4e70-972d-dafdaceb2aba');
      xhr.setRequestHeader('X-XSRF-TOKEN', crfToken);
      xhr.responseType = 'blob';
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            let contentType = dynamicType;
            let blob = new Blob([xhr.response], { type: contentType });
            observer.next(blob);
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };
      xhr.send(myData);
    });
  }

  generateOHSPDFInDocumnet(
    data: any,
    businessId: number,
    cultureInfo: string,
    portalId: number,
    ohsId = 0,
    userId: number,
    featureId: number,
    featureKey: number
  ) {
    let jsonString = JSON.stringify({ data });
    return this.http
      .post<any>(
        environment.BASE_URL +
          '/flexi/GeneratePDFInDocumnet/' +
          businessId +
          '/' +
          cultureInfo +
          '/' +
          portalId +
          '/' +
          ohsId +
          '/' +
          userId +
          '/' +
          featureId +
          '/' +
          featureKey,
        jsonString
      ).pipe(rxjsmap(result => result));
  }

  SaveOHSToDetailsActivity(
    dataItem: ActivityEditDto[],
    businessId: number,
    applicationId: number,
    userId: number
  ) {
    // Send dataItem as an array with a single item
    return this.http.post<any>(
      environment.BASE_URL +
        '/flexi/save-ohsDetailsToactivity/' +
        businessId +
        '/' +
        applicationId +
        '/' +
        userId,
      dataItem
    );
  }

  saveOHSActivity(data: any) {
    return this.http
      .post<any>(environment.BASE_URL + '/flexi/save-ohsactivity', data).pipe(rxjsmap(result => result));
  }

  getDefaultOhsActivity() {
    let cultureInfo = sessionStorage.getItem('languageMode');
    let languageId = LanguageId.Norwegian;
    return this.http
      .get<any>(
        environment.BASE_URL + '/flexi/get/defaultohsactivity/' + languageId
      ).pipe(rxjsmap(result => result));
  }

  getOhsActivityDetailsById(ohsId: number) {
    return this.http
      .get<any>(
        environment.BASE_URL +
          '/flexi/get/ohs-activity/' +
          ohsId +
          '/' +
          BaseServices.BusinessId
      ).pipe(rxjsmap(result => result));
  }

  DeleteOhsActivity(Id: number) {
    return this.http
      .delete(environment.BASE_URL + '/flexi/delete/' + Id).pipe(rxjsmap(result => result));
  }
}
